export class ContactModel {
  constructor(props) {
    this.id 						=		props['id'];
    this.idOrganization =		props['idOrganization'];
    this.name 					= 	props['name'];
    this.company 				=   props['company'];
    this.email 					= 	props['email'];
    this.phone 					= 	props['phone'];
    this.message 				=		props['message'];
    this.viewed 				= 	props['viewed'];
    this.idUserCreated 	= 	props['idUserCreated'];
  }
}